export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon-dark.9256593d034bcfe525ed871f3131ce36.png";